import { render, staticRenderFns } from "./ExpandableTransactionCheckList.vue?vue&type=template&id=18ca3cf8&scoped=true&"
import script from "./ExpandableTransactionCheckList.vue?vue&type=script&lang=js&"
export * from "./ExpandableTransactionCheckList.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableTransactionCheckList.vue?vue&type=style&index=0&id=18ca3cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ca3cf8",
  null
  
)

export default component.exports